import React, { useMemo, useState } from 'react';
import PhysicsLayout from './PhysicsLayout';

const g = 9.81;

const EnergyBench = () => {
  const [m, setM] = useState(8);
  const [h, setH] = useState(4);
  const [mu, setMu] = useState(0.12);
  const L = h / Math.sin(Math.PI / 6);

  const pe = m * g * h;
  const loss = mu * m * g * Math.cos(Math.PI / 6) * L;
  const ke = Math.max(0, pe - loss);
  const v = Math.sqrt((2 * ke) / m);
  const maxE = m * g * 8;

  const bars = useMemo(() => ([
    { name: 'PE top', v: pe, color: '#a78bfa' },
    { name: 'Friction', v: loss, color: '#f59e0b' },
    { name: 'KE bottom', v: ke, color: '#34d399' },
  ]), [pe, loss, ke]);

  return (
    <PhysicsLayout
      kicker="Bench 2 · energy is a ledger"
      title="Energy & work"
      lead="Drop from a 30° ramp. Height is credit. Friction is a fee along the path. Speed at the bottom is whatever is left."
    >
      <div className="pp-split">
        <div>
          <label className="pp-field">Mass {m} kg
            <input type="range" min="1" max="30" value={m} onChange={(e) => setM(+e.target.value)} />
          </label>
          <label className="pp-field">Height {h.toFixed(1)} m
            <input type="range" min="0.5" max="8" step="0.1" value={h} onChange={(e) => setH(+e.target.value)} />
          </label>
          <label className="pp-field">μ {mu.toFixed(2)}
            <input type="range" min="0" max="0.6" step="0.01" value={mu} onChange={(e) => setMu(+e.target.value)} />
          </label>
          <svg viewBox="0 0 320 160" width="100%" style={{ marginTop: '1rem' }}>
            <polygon points={`20,140 300,140 ${40 + (8 - h) * 12},${140 - h * 14}`} fill="rgba(167,139,250,0.12)" stroke="#a78bfa" />
            <circle cx={40 + (8 - h) * 12} cy={140 - h * 14 - 8} r="8" fill="#c4b5fd" />
          </svg>
        </div>
        <div className="pp-readout">
          <p className="pp-eq">½mv² = mgh − μmg cosθ · L</p>
          <strong>{v.toFixed(2)} m/s</strong>
          <p className="pp-note">at the bottom · ramp length {L.toFixed(2)} m</p>
          <div className="pp-bars">
            {bars.map((b) => (
              <div className="pp-bar-row" key={b.name}>
                <span>{b.name}</span>
                <div className="pp-bar"><i style={{ width: `${Math.min(100, (b.v / maxE) * 100)}%`, background: b.color }} /></div>
                <span>{b.v.toFixed(0)} J</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </PhysicsLayout>
  );
};

export default EnergyBench;
